export default "__VITE_ASSET__8Y9o_wrW__"